const bankArray = {
  'sber-card': [
    '402333',
    '417398',
    '423078',
    '427400',
    '427401',
    '427402',
    '427403',
    '427404',
    '427405',
    '427406',
    '427407',
    '427408',
    '427409',
    '427410',
    '427411',
    '427412',
    '427413',
    '427414',
    '427415',
    '427416',
    '427417',
    '427418',
    '427419',
    '427420',
    '427421',
    '427422',
    '427423',
    '427424',
    '427425',
    '427426',
    '427427',
    '427428',
    '427429',
    '427430',
    '427431',
    '427432',
    '427433',
    '427434',
    '427435',
    '427436',
    '427437',
    '427438',
    '427439',
    '427440',
    '427441',
    '427442',
    '427443',
    '427444',
    '427445',
    '427446',
    '427447',
    '427448',
    '427449',
    '427450',
    '427451',
    '427452',
    '427453',
    '427454',
    '427455',
    '427456',
    '427457',
    '427458',
    '427459',
    '427460',
    '427461',
    '427462',
    '427463',
    '427464',
    '427465',
    '427466',
    '427467',
    '427468',
    '427469',
    '427470',
    '427471',
    '427472',
    '427473',
    '427474',
    '427475',
    '427476',
    '427477',
    '427491',
    '427499',
    '427600',
    '427601',
    '427602',
    '427603',
    '427604',
    '427605',
    '427606',
    '427607',
    '427608',
    '427609',
    '427610',
    '427611',
    '427612',
    '427613',
    '427614',
    '427615',
    '427616',
    '427617',
    '427618',
    '427619',
    '427620',
    '427621',
    '427622',
    '427623',
    '427624',
    '427625',
    '427626',
    '427627',
    '427628',
    '427629',
    '427630',
    '427631',
    '427632',
    '427633',
    '427634',
    '427635',
    '427636',
    '427637',
    '427638',
    '427639',
    '427640',
    '427641',
    '427642',
    '427643',
    '427644',
    '427645',
    '427646',
    '427647',
    '427648',
    '427649',
    '427650',
    '427651',
    '427652',
    '427653',
    '427654',
    '427655',
    '427656',
    '427657',
    '427658',
    '427659',
    '427660',
    '427661',
    '427662',
    '427663',
    '427664',
    '427665',
    '427666',
    '427667',
    '427668',
    '427669',
    '427670',
    '427671',
    '427672',
    '427673',
    '427674',
    '427675',
    '427676',
    '427677',
    '427678',
    '427679',
    '427680',
    '427681',
    '427682',
    '427683',
    '427684',
    '427685',
    '427686',
    '427687',
    '427688',
    '427689',
    '427690',
    '427692',
    '427693',
    '427694',
    '427695',
    '427696',
    '427697',
    '427699',
    '427900',
    '427901',
    '427902',
    '427903',
    '427904',
    '427905',
    '427906',
    '427907',
    '427908',
    '427909',
    '427910',
    '427911',
    '427912',
    '427913',
    '427914',
    '427915',
    '427916',
    '427917',
    '427918',
    '427919',
    '427920',
    '427921',
    '427922',
    '427923',
    '427924',
    '427925',
    '427926',
    '427927',
    '427928',
    '427929',
    '427930',
    '427931',
    '427932',
    '427933',
    '427934',
    '427935',
    '427936',
    '427937',
    '427938',
    '427939',
    '427940',
    '427941',
    '427942',
    '427943',
    '427944',
    '427945',
    '427946',
    '427947',
    '427948',
    '427949',
    '427950',
    '427951',
    '427952',
    '427953',
    '427954',
    '427955',
    '427956',
    '427957',
    '427958',
    '427959',
    '427960',
    '427961',
    '427962',
    '427963',
    '427964',
    '427965',
    '427966',
    '427967',
    '427968',
    '427969',
    '427970',
    '427971',
    '427972',
    '427973',
    '427974',
    '427975',
    '427976',
    '427977',
    '427978',
    '427979',
    '427980',
    '427981',
    '427982',
    '427983',
    '427984',
    '427985',
    '427986',
    '427987',
    '427988',
    '427989',
    '427990',
    '427991',
    '427992',
    '427993',
    '427994',
    '427995',
    '427996',
    '427997',
    '427998',
    '427999',
    '481776',
    '481779',
    '481781',
    '485463',
    '515548',
    '515842',
    '520633',
    '522860',
    '524829',
    '527576',
    '531310',
    '533205',
    '533669',
    '542577',
    '543763',
    '543942',
    '544331',
    '545037',
    '545152',
    '545840',
    '546031',
    '546901',
    '546902',
    '546903',
    '546904',
    '546905',
    '546906',
    '546907',
    '546908',
    '546909',
    '546910',
    '546911',
    '546912',
    '546913',
    '546916',
    '546917',
    '546918',
    '546920',
    '546922',
    '546925',
    '546926',
    '546927',
    '546928',
    '546929',
    '546930',
    '546931',
    '546932',
    '546933',
    '546935',
    '546936',
    '546937',
    '546938',
    '546939',
    '546940',
    '546941',
    '546942',
    '546943',
    '546944',
    '546945',
    '546946',
    '546947',
    '546948',
    '546949',
    '546950',
    '546951',
    '546952',
    '546953',
    '546954',
    '546955',
    '546956',
    '546959',
    '546960',
    '546961',
    '546962',
    '546963',
    '546964',
    '546966',
    '546967',
    '546968',
    '546969',
    '546970',
    '546972',
    '546974',
    '546975',
    '546976',
    '546977',
    '546998',
    '546999',
    '547901',
    '547902',
    '547905',
    '547906',
    '547907',
    '547910',
    '547911',
    '547912',
    '547913',
    '547920',
    '547922',
    '547925',
    '547926',
    '547927',
    '547928',
    '547930',
    '547931',
    '547932',
    '547935',
    '547936',
    '547937',
    '547938',
    '547940',
    '547942',
    '547943',
    '547944',
    '547945',
    '547947',
    '547948',
    '547949',
    '547950',
    '547951',
    '547952',
    '547953',
    '547954',
    '547955',
    '547956',
    '547959',
    '547960',
    '547961',
    '547962',
    '547964',
    '547966',
    '547969',
    '547972',
    '547976',
    '547998',
    '547999',
    '548401',
    '548402',
    '548403',
    '548405',
    '548406',
    '548407',
    '548410',
    '548411',
    '548412',
    '548413',
    '548416',
    '548420',
    '548422',
    '548425',
    '548426',
    '548427',
    '548428',
    '548430',
    '548431',
    '548432',
    '548435',
    '548436',
    '548438',
    '548440',
    '548442',
    '548443',
    '548444',
    '548445',
    '548447',
    '548448',
    '548449',
    '548450',
    '548451',
    '548452',
    '548454',
    '548455',
    '548456',
    '548459',
    '548460',
    '548461',
    '548462',
    '548463',
    '548464',
    '548466',
    '548468',
    '548469',
    '548470',
    '548472',
    '548476',
    '548477',
    '548498',
    '548499',
    '550251',
    '559901',
    '605461',
    '639002',
    '676195',
    '676196',
    '676280',
    '677128'
  ],
  't-card': [
    '437772',
    '437773',
    '437784',
    '470127',
    '518901',
    '521324',
    '524468',
    '548387',
    '551960',
    '553420'
  ],
  'alfa-card': [
    '408396',
    '408397',
    '410584',
    '415400',
    '415428',
    '415429',
    '415481',
    '415482',
    '419539',
    '419540',
    '426101',
    '426102',
    '426113',
    '426114',
    '427714',
    '428804',
    '428905',
    '428906',
    '431416',
    '431417',
    '431727',
    '434135',
    '438143',
    '439000',
    '439077',
    '440237',
    '458279',
    '458280',
    '458281',
    '458410',
    '458411',
    '458443',
    '458450',
    '465227',
    '475791',
    '477714',
    '477932',
    '477960',
    '477964',
    '478752',
    '479004',
    '479087',
    '480623',
    '510126',
    '519747',
    '519778',
    '521178',
    '522828',
    '523701',
    '530827',
    '531237',
    '537643',
    '548601',
    '548655',
    '548673',
    '548674',
    '552175',
    '552186',
    '555156',
    '555921',
    '555928',
    '555933',
    '555947',
    '555949',
    '555957',
    '558334',
    '627119',
    '676230'
  ],
  'raif-card': [
    '220030',
    '402177',
    '402178',
    '402179',
    '404807',
    '404885',
    '415430',
    '420705',
    '422287',
    '425620',
    '425884',
    '425885',
    '432498',
    '445977',
    '446916',
    '446917',
    '447603',
    '447624',
    '462729',
    '462730',
    '462758',
    '462779',
    '465578',
    '476036',
    '478741',
    '490816',
    '508406',
    '510069',
    '510070',
    '515876',
    '528053',
    '528808',
    '528809',
    '530867',
    '533594',
    '533616',
    '536392',
    '537965',
    '542772',
    '544237',
    '545115',
    '547613',
    '548164',
    '550484',
    '553496',
    '558273',
    '558536',
    '558622',
    '676333',
    '676625'
  ],
  'vtb-card': [
    '402107',
    '416927',
    '416928',
    '418260',
    '418261',
    '418262',
    '446674',
    '472313',
    '489195',
    '489196',
    '510060',
    '510495',
    '512378',
    '512450',
    '516570',
    '516587',
    '518505',
    '524477',
    '526532',
    '527785',
    '527798',
    '530229',
    '531452',
    '534493',
    '534601',
    '554384',
    '559066',
    '671109',
    '671111',
    '671148',
    '671172',
    '677151'
  ],
  'psb-card': [
    '220003',
    '402507',
    '404906',
    '411791',
    '424561',
    '424562',
    '424563',
    '426803',
    '426804',
    '446050',
    '447817',
    '447818',
    '447824',
    '451382',
    '472345',
    '472346',
    '472347',
    '472348',
    '476206',
    '476207',
    '476208',
    '482413',
    '515848',
    '516473',
    '518946',
    '518970',
    '518977',
    '518981',
    '520085',
    '520088',
    '521124',
    '523688',
    '525494',
    '526280',
    '528701',
    '529160',
    '530441',
    '531534',
    '531943',
    '534462',
    '534495',
    '535023',
    '535058',
    '539621',
    '539704',
    '539861',
    '541269',
    '541503',
    '542340',
    '543874',
    '544800',
    '545350',
    '546766',
    '547329',
    '548172',
    '548269',
    '548429',
    '549425',
    '549439',
    '549524',
    '554279',
    '554759',
    '554781',
    '557981',
    '558254',
    '558268',
    '558516',
    '558672',
    '670508',
    '670583',
    '670611',
    '670654',
    '670661',
    '676444',
    '677263',
    '677370',
    '677371',
    '677372',
    '677405',
    '677461',
    '677462',
    '677506'
  ],
  'mts-card': [
    '404204',
    '404224',
    '404266',
    '404267',
    '404268',
    '404269',
    '406356',
    '457802',
    '462013',
    '517955',
    '521159',
    '524602',
    '533213',
    '533736',
    '536672',
    '540616',
    '541435',
    '544123',
    '548035',
    '550583',
    '552618',
    '676884',
    '677684'
  ],
  'otkr-card': [
    '401173',
    '404586',
    '405658',
    '405870',
    '407178',
    '409356',
    '409357',
    '409358',
    '414076',
    '429037',
    '429038',
    '429039',
    '429040',
    '429096',
    '431165',
    '431166',
    '432417',
    '434146',
    '434147',
    '434148',
    '446065',
    '457816',
    '457817',
    '457818',
    '457819',
    '458493',
    '467485',
    '467486',
    '467487',
    '484800',
    '485649',
    '514017',
    '515243',
    '515899',
    '516354',
    '516387',
    '517508',
    '522117',
    '524838',
    '525719',
    '529260',
    '530183',
    '530403',
    '531674',
    '532130',
    '532301',
    '534469',
    '534661',
    '534669',
    '535027',
    '535108',
    '536095',
    '542289',
    '542475',
    '542501',
    '543019',
    '544092',
    '544218',
    '544343',
    '544499',
    '544573',
    '544962',
    '547449',
    '547616',
    '548484',
    '549024',
    '549025',
    '549848',
    '550446',
    '552708',
    '557946',
    '557948',
    '558620',
    '559264',
    '670518',
    '670587',
    '676231',
    '676697'
  ],
  'otp-card': [
    '402311',
    '402312',
    '402313',
    '409681',
    '419636',
    '432947',
    '432948',
    '432949',
    '436865',
    '459230',
    '515774',
    '516009',
    '517202',
    '521330',
    '522470',
    '526839',
    '529968',
    '531428',
    '533685',
    '545214'
  ],
  'home-card': [
    '406364',
    '445433',
    '445434',
    '445435',
    '445436',
    '446098',
    '446915',
    '449572',
    '472445',
    '516444',
    '522199',
    '524835',
    '525933',
    '531327',
    '536500',
    '536511',
    '545762',
    '548745',
    '557734'
  ],
  'uralSib-card': [
    '400244',
    '404111',
    '409682',
    '410213',
    '419370',
    '419804',
    '419805',
    '419810',
    '422372',
    '424204',
    '424205',
    '424206',
    '424207',
    '424290',
    '424291',
    '424473',
    '424474',
    '424475',
    '424476',
    '426390',
    '426396',
    '427827',
    '427828',
    '429196',
    '429197',
    '429811',
    '431112',
    '431113',
    '431114',
    '432169',
    '432259',
    '432260',
    '433011',
    '434149',
    '440610',
    '440664',
    '440665',
    '440666',
    '440668',
    '440680',
    '440682',
    '440683',
    '440689',
    '440690',
    '442466',
    '453558',
    '453559',
    '453560',
    '453561',
    '459290',
    '466047',
    '466048',
    '466049',
    '466050',
    '467810',
    '467811',
    '467812',
    '470342',
    '471439',
    '471440',
    '471441',
    '471499',
    '483973',
    '483974',
    '483975',
    '483976',
    '483977',
    '483979',
    '483980',
    '489169',
    '490815',
    '510172',
    '510411',
    '510412',
    '510424',
    '510429',
    '510436',
    '510444',
    '510483',
    '510494',
    '510499',
    '510508',
    '511741',
    '512298',
    '512394',
    '512419',
    '512424',
    '512510',
    '512636',
    '512741',
    '512777',
    '512788',
    '513222',
    '514515',
    '515777',
    '515792',
    '515840',
    '515844',
    '515861',
    '515887',
    '515900',
    '516025',
    '516161',
    '516206',
    '516445',
    '516448',
    '518025',
    '518048',
    '518095',
    '518223',
    '518275',
    '518316',
    '518318',
    '518372',
    '518392',
    '518449',
    '518499',
    '518522',
    '518533',
    '518607',
    '518621',
    '518683',
    '518727',
    '518805',
    '518874',
    '518909',
    '518911',
    '519346',
    '520006',
    '520035',
    '520996',
    '521379',
    '521381',
    '521658',
    '521779',
    '521820',
    '521847',
    '521879',
    '522022',
    '522083',
    '522212',
    '522230',
    '522965',
    '522970',
    '523281',
    '524004',
    '524390',
    '524776',
    '524818',
    '525236',
    '525248',
    '525443',
    '525696',
    '525714',
    '525751',
    '526857',
    '526992',
    '527001',
    '527196',
    '527574',
    '527658',
    '528014',
    '528068',
    '528704',
    '529273',
    '529293',
    '529436',
    '529450',
    '529461',
    '529860',
    '530035',
    '530142',
    '530143',
    '530145',
    '530279',
    '530526',
    '530758',
    '530979',
    '531038',
    '531073',
    '531207',
    '531657',
    '531858',
    '532320',
    '532328',
    '532472',
    '532475',
    '532583',
    '533166',
    '533611',
    '534128',
    '534132',
    '534136',
    '534148',
    '534156',
    '534194',
    '534296',
    '534927',
    '536176',
    '536186',
    '536400',
    '536454',
    '536960',
    '537705',
    '537709',
    '537715',
    '537730',
    '537734',
    '538397',
    '538800',
    '538998',
    '539037',
    '539617',
    '539710',
    '539852',
    '540111',
    '540400',
    '540687',
    '540708',
    '540768',
    '540794',
    '540834',
    '540923',
    '541279',
    '541354',
    '541456',
    '541632',
    '541789',
    '541920',
    '541983',
    '542112',
    '542246',
    '543015',
    '543354',
    '543435',
    '543749',
    '543807',
    '544195',
    '544272',
    '544326',
    '544367',
    '544369',
    '544417',
    '544439',
    '544462',
    '544552',
    '545200',
    '545266',
    '545272',
    '545472',
    '545539',
    '545540',
    '545592',
    '545638',
    '545655',
    '545701',
    '545742',
    '545744',
    '545761',
    '545778',
    '545789',
    '545792',
    '545799',
    '545817',
    '545868',
    '545916',
    '546339',
    '546340',
    '546468',
    '546551',
    '546593',
    '546662',
    '546679',
    '546718',
    '546842',
    '546844',
    '547228',
    '547253',
    '547257',
    '547258',
    '547298',
    '547300',
    '547306',
    '547314',
    '547319',
    '547324',
    '547421',
    '547447',
    '547547',
    '547563',
    '547576',
    '547580',
    '547665',
    '547699',
    '547761',
    '547796',
    '547851',
    '548137',
    '548138',
    '548177',
    '548205',
    '548214',
    '548246',
    '548249',
    '548266',
    '548268',
    '548272',
    '548291',
    '548294',
    '548326',
    '548393',
    '548453',
    '548504',
    '548511',
    '548571',
    '548588',
    '548704',
    '548706',
    '548713',
    '548752',
    '548899',
    '548934',
    '548996',
    '548997',
    '549014',
    '549015',
    '549229',
    '549251',
    '549255',
    '549256',
    '549257',
    '549264',
    '549274',
    '549283',
    '549285',
    '549303',
    '549306',
    '549307',
    '549347',
    '549401',
    '549424',
    '549447',
    '549454',
    '549483',
    '549522',
    '549647',
    '549654',
    '549716',
    '549830',
    '549873',
    '549881',
    '550006',
    '550468',
    '552845',
    '553000',
    '553581',
    '553584',
    '554546',
    '554562',
    '554581',
    '554607',
    '554615',
    '554651',
    '556057',
    '557036',
    '557106',
    '557107',
    '557970',
    '558275',
    '558326',
    '558354',
    '558356',
    '558374',
    '558391',
    '558463',
    '558651',
    '558664',
    '558690',
    '605462',
    '670992',
    '670995',
    '671106',
    '671136',
    '676528',
    '676984',
    '677261',
    '677382',
    '677408',
    '677430',
    '677431',
    '679074'
  ],
  'gazprom-card': [
    '220001',
    '404136',
    '404270',
    '421398',
    '424917',
    '424974',
    '424975',
    '424976',
    '426890',
    '427326',
    '430299',
    '433316',
    '465882',
    '487415',
    '487416',
    '487417',
    '489354',
    '514082',
    '516454',
    '517375',
    '517593',
    '518228',
    '518373',
    '518704',
    '518816',
    '518902',
    '521155',
    '522193',
    '522477',
    '522826',
    '522988',
    '522989',
    '525740',
    '525784',
    '525833',
    '526483',
    '527444',
    '529278',
    '529488',
    '530114',
    '530993',
    '531305',
    '532684',
    '533327',
    '534130',
    '534171',
    '534196',
    '536995',
    '537627',
    '539839',
    '540664',
    '540674',
    '542255',
    '543672',
    '543724',
    '543762',
    '544026',
    '544561',
    '545101',
    '545807',
    '547348',
    '548027',
    '548999',
    '549000',
    '549098',
    '549600',
    '549614',
    '552055',
    '552702',
    '556052',
    '558355',
    '559255',
    '559992',
    '671122',
    '676454',
    '676990',
    '677110',
    '677484',
    '677585'
  ],
  'pochta-bank': [
    '220077',
    '405990',
    '405991',
    '405992',
    '405993'
  ]
}

/**
 * !все расчеты с баблом идут через умножение на 100 значения, которое вернул бэк!
 * ! поэтому эта функция ждет 1 000 рублей как 1 000 00 !
 * эта функция разбирает число и отображает пользователю целую часть рубли и копейки
 * @param value {int} чиселко, имеется в виду деньги * 100
 * @returns {string} вернет число с копейками если они есть.
 */
export const moneyIntToStr = function (value) {
  const moneyStr = value.toString();
  const rubl = (moneyStr.length > 2) ? moneyStr.substring(0, moneyStr.length - 2) : '0';
  const formatedRubl = rubl.split('').reverse().join('')
    .match(/\d{0,3}/g).join(' ')
    .split('').reverse().join('');
  const kop = moneyStr.substring(moneyStr.length - 2) === '00' ? '' : '.' + moneyStr.substring(moneyStr.length - 2);
  return formatedRubl + kop + ' ₽';
};
/**
 * !все расчеты с баблом идут через умножение на 100 значения, которое вернул бэк!
 * ! поэтому эта функция ждет 1 000 рублей как 1 000 00 !
 * эта функция приводит, умноженное на 100 число в сумму, корректную для отправки на бек. С плавающей точкой, если были копейки или целым числом, если без'
 * @param value сумма, умноженная на 100
 * @returns {number}
 */
export const prepareSumToBackend = function (value) {
  const t = value.toString();
  return t.length > 2 && t[t.length - 1] !== '0' && t[t.length - 2] !== '0' ? parseFloat(t / 100) : parseInt(t / 100, 10);
};

/**
 * вернет дату в формате вне хогвартса
 * @param value тут нужна дата yyyy-mm-dd
 * @returns {string} вернет dd.mm.yyyy
 */
export const formatDateDDMMYYYY = function (value) {
  if (value) {
    const dtArr = value.split('-');
    return dtArr[2] + '.' + dtArr[1] + '.' + dtArr[0];
  }
  return ''
};
/**
 * формирование пути к файлу иконки банка по БИН-у.
 * @param binCode код бин карты
 * @returns {*} - сформированный путь к файлу
 */
export const getBankIcon = function (binCode) {
  let iconName = 'default-card'
  for (const key in bankArray) {
    for (const keyInner in bankArray[key]) {
      if (bankArray[key][keyInner] === binCode) {
        iconName = key
      }
    }
  }
  return require('../assets/svg/cardsSvg/' + iconName + '.svg')
};

/**
 * Разветвление дальнейших действий после запроса
 * @param result
 * @returns {Promise<unknown>}
 */
export const catchError = function (result) {
  return new Promise((resolve, reject) => {
    if (result.errorCode > 0) {
      alert(result.errorMessage);
      reject(result);
    } else {
      resolve(result);
    }
  })
};
